export enum AssetGalleryFormType {
  FACADE = "facade",
  EXTERNAL_COLOR_SCHEME = "externalColorScheme",
  INTERNAL_COLOR_SCHEME = "internalColorScheme",
  INCLUSION = "inclusion",
  OPTIONAL_UPGRADE = "optionalUpgrade",
}

export const colorSchemeTypes = [
  AssetGalleryFormType.EXTERNAL_COLOR_SCHEME,
  AssetGalleryFormType.INTERNAL_COLOR_SCHEME,
];
